import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexDelegation from "./delegations/IndexDelegation";
import IndexRestrictRequest from "./restrictRequests/IndexRestrictRequest";
import IndexPrivilege from "./previleges/IndexPrivilege";
import IndexIpRestriction from "./IpRestrictions/IndexIpRestriction";
import IndexCustomDashboard from "./customDashboard/IndexCustomDashboard";
import CreateCustomDashboard from "./customDashboard/components/CreateCustomDashboard";
import UpdateCustomDashboard from "./customDashboard/components/UpdateCustomDashboard";
import { guardElement } from "@comps/components";

const WorkflowManagementModules = () => {
  return (
    <Routes>
      <Route path="delegation" element={ guardElement(<IndexDelegation modkey="delegations" />, "delegations") } />
      <Route path="restrictRequests" element={ guardElement(<IndexRestrictRequest modkey="restrictRequests" />, "restrictRequests") } />
      <Route path="privilege" element={ guardElement(<IndexPrivilege modkey="privileges" />, "privileges") } />
      <Route path="ipRestriction" element={ guardElement(<IndexIpRestriction modkey="ipRestrictions" />, "ipRestrictions") } />
      <Route path="customDashboard/index" element={ guardElement(<IndexCustomDashboard modkey="customDashboard" />, "customDashboard") } />
      <Route path="customDashboard/index/create" element={ guardElement(<CreateCustomDashboard modkey="customDashboard" />, "customDashboard", "create") } />
      <Route path="customDashboard/index/edit/:id" element={ guardElement(<UpdateCustomDashboard modkey="customDashboard" disabled={ false } />, "customDashboard", "update") } />
      <Route path="customDashboard/index/view/:id" element={ guardElement(<UpdateCustomDashboard modkey="customDashboard" disabled={ true } />, "customDashboard") } />

    </Routes>
  );
}

export default WorkflowManagementModules;
